import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { CATEGORIES } from '../data/site';
import { GUIDES, REVIEWS } from '../data/site';
import { GuideCard, ReviewCard } from '../components/Cards';
export function CategoryPage() {
  const {
    pathname
  } = useLocation();
  const slug = pathname.replace('/', '');
  const category = CATEGORIES[slug];
  if (!category) return <Navigate to="/" replace data-id="element-244" />;
  const guides = GUIDES.filter(g => g.category === category.name);
  const reviews = REVIEWS.filter(r => r.category === category.name);
  return <>
      {/* Hero band */}
      <section className="relative w-full" data-id="element-245">
        <div className="relative h-[360px] md:h-[440px] overflow-hidden" data-id="element-246">
          <img src={category.image} alt={category.headline} className="h-full w-full object-cover" data-id="element-247" />
          <div className="absolute inset-0 bg-ink/55" data-id="element-248" />
          <div className="absolute inset-0 flex items-end" data-id="element-249">
            <div className="max-w-editorial mx-auto px-6 pb-12 w-full" data-id="element-250">
              <p className="eyebrow text-trust-200 mb-4" data-id="element-251">{category.name}</p>
              <h1 className="font-serif tracking-tightest text-paper text-4xl md:text-6xl leading-[1.02] max-w-3xl" style={{
              fontWeight: 500
            }} data-id="element-252">
                {category.headline}
              </h1>
              <p className="mt-5 text-lg text-stone-200 max-w-2xl leading-relaxed" data-id="element-253">
                {category.description}
              </p>
            </div>
          </div>
        </div>
      </section>

      {reviews.length > 0 && <section className="max-w-editorial mx-auto px-6 py-16" data-id="element-254">
          <h2 className="font-serif text-2xl tracking-tightest text-ink mb-8" style={{
        fontWeight: 500
      }} data-id="element-255">
            Latest reviews
          </h2>
          <div className="grid gap-8 md:grid-cols-3" data-id="element-256">
            {reviews.map(r => <ReviewCard key={r.slug} review={r} data-id="element-257" />)}
          </div>
        </section>}

      {guides.length > 0 && <section className="max-w-editorial mx-auto px-6 py-16 border-t border-stone-200" data-id="element-258">
          <h2 className="font-serif text-2xl tracking-tightest text-ink mb-8" style={{
        fontWeight: 500
      }} data-id="element-259">
            Buying guides
          </h2>
          <div className="grid gap-8 md:grid-cols-3" data-id="element-260">
            {guides.map(g => <GuideCard key={g.slug} guide={g} data-id="element-261" />)}
          </div>
        </section>}

      {guides.length === 0 && reviews.length === 0 && <div className="max-w-editorial mx-auto px-6 py-24 text-center text-stone-500" data-id="element-262">
          New coverage in this category is on the way.
        </div>}
    </>;
}